import type { ReactNode } from "react";
import cx from "ui/cx";
import styles from "./Header.module.scss";

export interface HeaderProps {
  left?: ReactNode;
  center?: ReactNode;
  right?: ReactNode;
  className?: string;
}

export default function Header({ left, center, right, className }: HeaderProps) {
  return (
    <header className={cx(styles.wrapper, className)} data-testid="header">
      {left}
      {center}
      {right}
    </header>
  );
}
